import { createSelector, createSlice } from '@reduxjs/toolkit';

const companySlice = createSlice({
    initialState: {
        data: [],
        isLoading: false,
    },
    name: 'companies',
    reducers: {
        fetchCompanies: state => {
            state.data = [];
            state.isLoading = true;
        },
        companiesFetched: (state, { payload }) => {
            const { results } = payload;

            console.log('ABC : ', results);
            state.data = results;
            state.isLoading = false;
            console.log('state : ', state.data);
        },
        companiesFetchedFailed: state => {
            state.isLoading = false;
        },
    },
});

// selectors
const getSelf = state => state.companies;

export const getCompanies = createSelector(getSelf, state => state.data);

export const isLoading = createSelector(getSelf, state => state.isLoading);

export const { fetchCompanies, companiesFetched, companiesFetchedFailed } =
    companySlice.actions;

export default companySlice.reducer;
